$(function(){
    var tab = $('.image-tab__tab');
    var image = $('.image-tab__img');

    
    tab.click(function() {
        tabID = $(this).attr('data-tab');
        // image.removeClass('image-tab__img--active');
        // $('.image-tab__img' + '#' + tabID).addClass('image-tab__img--active');

        tab.removeClass('image-tab__tab--active');
        $(this).addClass('image-tab__tab--active');
    });
});